// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import AddOutlineSvg from '@rsuite/icon-font/lib/action/AddOutline';
var AddOutline = createSvgIcon({
  as: AddOutlineSvg,
  ariaLabel: 'add outline',
  category: 'action',
  displayName: 'AddOutline'
});
export default AddOutline;